/** Dispute categories for demand records. */
export const DISPUTE_TYPES = Object.freeze([
  {
    value: 'CORPORATE_BUSINESS_DEBT',
    label: 'Corporate & Business Debt',
    tooltip: 'For businesses owed money due to broken contracts or unpaid bills.',
  },
  {
    value: 'EMPLOYMENT_LABOR',
    label: 'Employment & Labor',
    tooltip:
      'For workers seeking compensation for unpaid wages, wrongful firing, discrimination, or retaliation.',
  },
  {
    value: 'FAMILY_DOMESTIC',
    label: 'Family & Domestic',
    tooltip:
      'For parents or spouses seeking money related to child support, alimony, or dividing shared property.',
  },
  {
    value: 'INTELLECTUAL_PROPERTY',
    label: 'Intellectual Property (IP)',
    tooltip:
      'For creators and brands losing money because someone copied or misused their trademark, copyright, patent, or license.',
  },
  {
    value: 'PERSONAL_INJURY',
    label: 'Personal Injury',
    tooltip:
      'For individuals seeking payment for injuries from car accidents, falls, unsafe products, or general carelessness.',
  },
  {
    value: 'REAL_ESTATE',
    label: 'Real Estate',
    tooltip:
      'For buyers, sellers, renters, or builders dealing with financial losses from broken leases, hidden property defects, or construction issues.',
  },
  {
    value: 'MARITIME_ADMIRALTY',
    label: 'Maritime & Admiralty',
    tooltip:
      'For maritime workers, ship owners, or offshore companies facing losses from at-sea injuries, damaged cargo, or unpaid port services.',
  },
  {
    value: 'BANKING_FINANCE',
    label: 'Banking & Finance',
    tooltip:
      'For banks and lenders recovering money from defaulted loans, unpaid credit cards, or overdrawn accounts.',
  },
  {
    value: 'CIVIL_RIGHTS',
    label: 'Civil Rights',
    tooltip:
      'For individuals or groups seeking compensation for civil rights violations, including disability (ADA) or housing (FHA) discrimination.',
  },
  {
    value: 'HEALTHCARE',
    label: 'Healthcare',
    tooltip:
      'For medical providers or insurance companies dealing with financial losses from licensing issues, rule violations, fraud, or past due bills.',
  },
]);

/** Older values that may still exist on saved demands. */
const LEGACY_DISPUTE_LABELS = Object.freeze({
  BREACH_OF_CONTRACT: 'Breach of Contract',
  UNPAID_DEBT: 'Unpaid Debt',
  LANDLORD_TENANT: 'Landlord/Tenant Conflict',
  PROPERTY_DAMAGE: 'Property Damage',
  OTHER: 'Other',
});

export const AMOUNT_OWED_TIP =
  'Consider adding DemandJet’s fee to your invoice and amount owed. Whether collection costs can be added depends on your agreement and applicable law.';

/** Scannable list shown in the in-app evidence help popup. */
export const EVIDENCE_TYPES = Object.freeze([
  {
    title: 'Invoices & billing statements',
    detail: 'Signed or issued invoices, account statements, and balances due.',
  },
  {
    title: 'Contracts & agreements',
    detail: 'Signed contracts, terms of service, purchase orders, or work orders.',
  },
  {
    title: 'Payment records',
    detail: 'Partial payments, bounced checks, bank transfers, or failed payment notices.',
  },
  {
    title: 'Written communications',
    detail: 'Emails, texts, letters, or messages acknowledging the debt or dispute.',
  },
  {
    title: 'Delivery & performance proof',
    detail: 'Shipping receipts, delivery confirmations, timesheets, or completion records.',
  },
  {
    title: 'Photos & supporting files',
    detail: 'Images, PDFs, or other documents that show damage, goods, or services provided.',
  },
]);

export const EVIDENCE_TYPES_INTRO =
  'Upload clear copies of anything that proves the amount owed and why it’s due. PDFs, images, Word, and Excel files work best.';

export const EVIDENCE_TYPES_FOOTNOTE =
  'You can upload more than one file. Stronger evidence usually means a faster, clearer demand.';

export function disputeLabel(value) {
  const key = String(value || '').trim();
  if (!key) return '—';
  return (
    DISPUTE_TYPES.find((d) => d.value === key)?.label ||
    LEGACY_DISPUTE_LABELS[key] ||
    key ||
    '—'
  );
}

export function disputeTooltip(value) {
  const key = String(value || '').trim();
  return DISPUTE_TYPES.find((d) => d.value === key)?.tooltip || '';
}
